import { useQuery } from '@tanstack/react-query';

import { formatData } from 'components/helpers/reactQuery';

export function useAssignableCompaniesQuery() {
  return useQuery({
    queryKey: ['assignableCompanies'],
    queryFn: async () => {
      const response = await axios.get('/assignable_companies');
      return response.data;
    },
    select: (data) => formatData({ data }),
  });
}
